import { Markup } from 'interweave'
import React, { useEffect, useState } from 'react'
import $ from "jquery"

function Accordion({ id, idx, question, answer, setId }) {
    const [show, SetShow] = useState(false);
   const click=(e,id)=>{
                          if ($('.aa'+id).is(':visible')) {
                            $(".aa"+id).slideUp(600);
                            $(".plusminus"+id).text('+');
                          }
                          else
                          {
                            $(".accordion_body").slideUp(600);
                            $(".plusminus").text('+');
                            $('.aa'+id).slideDown(600); 
                            $(".plusminus"+id).text('-');
                          }
   }


    return (
        // <div className="accordion_container">
        //     <div className="accordion_head" data-id="1">
        //         <span>{question}</span>
        //         <div className="plusminus plusminus1" onClick={() => { SetShow(!show) }}>
        //             {show ? "-" : "+"}
        //         </div>
        //     </div>
        //     {<div className={show ? "accordion_body_active" : "accordion_body"}>
        //         <Markup content={answer} />
        //     </div>}
        // </div>
        <div className="accordion_container">
          <div className="accordion_head" onClick={(e)=>click(e,idx)} data-id={idx}><span><small style={{fontWeight:600,fontSize:"16px"}}>{idx+1}.</small> {question}</span> <div className={`plusminus plusminus${idx}`}>+</div></div>
             <div className={"accordion_body aa"+idx} style={{display: "none"}}>
             <Markup content={answer} />
          </div>
       </div>
    )
}

export default Accordion